import React from "react";
import "../pages/Home.css";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <div id="container">
      {/* ===== Marquee ===== */}
      <div className="style20">
        <div className="marquee1">
          <p>मुद्दत समाप्ती : 14/11/2026 | Helpline Contact : 9975977462</p>
        </div>
      </div>
      {/* ===== Header ===== */}
      <header
        className="header"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
          padding: "10px",
          position: "relative",
          
          
          // width:"75px",
          // height:"75px",
          // marginRight:"15px",
          // borderRadius:"50px",
          // border:"2px,solid #333",
        }}
      >
        {/* Logo on left side */}
        <div className="logo" style={{ position: "absolute", left: "20px", top: "20px",background:"transparent",mixBlendMode:"multiply"  }}>
          <img
            src={`${process.env.PUBLIC_URL}/images/sj.jpg`}
            alt="National-Logo"
            style={{ width: "100px", height: "auto", }}
          />
        </div>

        {/* Header Titles */}
        <div style={{ textAlign: "center" }}>
          <h2 className="style1">ग्रामपंचायत बेला</h2>
          <h2 className="style1">पंचायत समिती उमरेड, जिल्हा परिषद नागपुर</h2>
          <h2 className="style1">महाराष्ट्रातील एकमेव ग्रामपंचायत उपक्रम</h2>
          <h1 className="style1">   <u>9001:2015 Certified</u> </h1>  <img
            src={`${process.env.PUBLIC_URL}/images/iso.png`}
            alt="Grampanchayat Logo"
            style={{ width: "45px", height: "auto" }}
          />
        </div>

        {/* === RIGHT SIDE IMAGES === */}
        <div
          style={{
            position: "absolute",
            right: "20px",
            display: "flex",
            gap: "20px",
            alignItems: "center",
            top: "20px"
          }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/images/Gadgemaharaj.jpg`}
            alt="Gadge Maharaj"
            style={{ width: "70px", height: "70px", borderRadius: "6px" }}
          />

          <img
            src={`${process.env.PUBLIC_URL}/images/tujdojimaharaj.jpeg`}
            alt="Tujdoji Maharaj"
            style={{ width: "70px", height: "auto", borderRadius: "6px" }}
          />
        </div>
      </header>

      {/* ===== Marquee ===== */}
      <div className="style20">
        <div className="marquee">
          <p>ग्रामपंचायत बेला – तालुका उमरेड – जिल्हा नागपुर</p>
        </div>
      </div>

      {/* ===== Main Menu ===== */}
      <nav className="menuicons">
        <ul>
          <li><Link to="/aboutus">About Us</Link></li>
          <li><Link to="/">मुखपृष्ठ</Link></li>
          <li><Link to="/gramsevakpage">ग्रामसेवक</Link></li>
          <li><Link to="/gallery">Gallery</Link></li>
          <li><Link to="/vikas">विकास कामे</Link></li>
          <li><Link to="/sabha">सभेची माहिती</Link></li>
          <li><Link to="/contact">संपर्क करा</Link></li>
          
          <li><Link to="/team">सदस्य</Link></li>
        </ul>
      </nav>

      {/* ===== Sub Menu ===== */}
      <div className="menuicons">
        <ul>
          <li><Link to="/janmdakhala">जन्म दाखला</Link></li>
          <li><Link to="/death">मृत्यू दाखला</Link></li>
          <li><Link to="/vivah">विवाह दाखला</Link></li>
          <li><Link to="/gramsevak">ग्रामपंचायत अधिकारी</Link></li>
          <li><Link to="/sarpanch">सरपंच कार्यकाल</Link></li>
          <li><Link to="/upsarpanch">उपसरपंच कार्यकाल</Link></li>
          <li><Link to="/sadasya">सदस्य कार्यकारणी</Link></li>
        </ul>
      </div>

      {/* ===== Main Section ===== */}
      <main>
        <h3 className="style2">कार्यकारी मंडळ ग्रामपंचायत बेला</h3>

        <div style={{ overflow: "auto", height: "300px" }}>
          <table>
            <thead>
              <tr>
                <th>अ.क्र.</th>
                <th>नाव</th>
                <th>पद</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["1", "श्री  अरुण देवराव बालपांडे", "सरपंच"],
                ["2", "श्री प्रशांत देवरावजी लांबट", "उपसरपंच"],
                ["3", "श्री. संजय बाळाजी पुरके ", "सदस्य"],
                ["4", "श्री. राजू दत्तू रोडे", "सदस्य"],
                ["5", " श्री. अभिनव परसरामजी गोळघाटे", "सदस्य"],
                ["6", "सौ. कल्पना रमण पादाडे", "सदस्य"],
                ["7", "सौ. शालू कवडूजी लांडे", "सदस्य"],
                ["8", "सौ. नाजुका यशवंत धनकासार ", "सदस्य"],
                ["9", "सौ. सुनीता अरुण कावळे", "सदस्य"],
                ["10", "सौ. शीला बळीराम गंधारे ", "सदस्य"],
                ["11", "श्री. मिलींद कवडुजी सातकर", "सदस्य"],
                ["12", "सौ. माया शंकर आंबटकर ", "सदस्य"],
                ["13", "सौ. रेखा विठ्ठल उरकुडे ", "सदस्य"],
                ["14", "सौ.हेमलता दशरथ झगडे ", "सदस्य"],
                ["15", "श्री.नितीन सूर्यमान बालपांडे ", "सदस्य"],
                ["16", "सौ.नीतू किशोर आत्राम ", "सदस्य"],
                ["17", "श्री.योगेश बाळकृष्ण गाते ", "सदस्य"],
                  ["18", "श्री सुरज आनंदराव कांबळे ", "सदस्य"],

              ].map((row, index) => (
                <tr className="EvenRowColor" key={index}>
                  {row.map((cell, i) => (
                    <td key={i}>{cell}</td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </main>

      {/* ===== Footer Section ===== */}
      <footer className="footer-section">
        <ul className="social-icons">
          <li>
            <a href="https://www.facebook.com/share/17aJakr2jm/" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/facebook.jpeg`} alt="Facebook" />
            </a>
          </li>
          <li>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/twit.jpeg`} alt="Twitter" />
            </a>
          </li>
          <li>
            <a href="https://www.instagram.com/reel/C2kcwFBByhfsGqzMoHkTEAMjZRwz7DExDdHw-A0/?igsh=N2RmeHJnamEyNmpr" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/instagaram.jpeg`} alt="Instagram" />
            </a>
          </li>
          <li>
            <a href="https://youtube.com" target="_blank" rel="noopener noreferrer">
              <img src={`${process.env.PUBLIC_URL}/images/youtube.jpeg`} alt="YouTube" />
            </a>
          </li>
        </ul>

        <p className="footer-links">
          <Link to="/copyright">Copyright Policy</Link> |{" "}
          <Link to="/disclaimer">Disclaimer</Link> |{" "}
          <Link to="/privacy">Privacy Policy</Link> |{" "}
          <Link to="/contact">Contact Us</Link>
        </p>

        <p>
          Website Designed, Developed & Maintained by{" "}
          <b>Certnexus India Pvt. Ltd. Nagpur</b>.<br />
          Content provided by Grampanchayat Office, Government of Maharashtra.
        </p>

        <p>© 2025 Certnexus India Pvt. Ltd. Nagpur</p>

        <div className="footer-logos">
          <a href="https://swachhbharatmission.ddws.gov.in/" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/swachh-bharat.jpeg`} alt="Swachh Bharat" />
          </a>
          <a href="https://digitalindia.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/digital-india-logo.jpeg`} alt="Digital India" />
          </a>
          <a href="https://data.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/data-gov-logo.jpeg`} alt="Data Portal" />
          </a>
          <a href="https://www.india.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/portal.jpeg`} alt="National Portal" />
          </a>
          <a href="https://mygov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/mygov.jpeg`} alt="MyGov" />
          </a>
          <a href="https://www.meity.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/Meity_logo.jpeg`} alt="MeitY" />
          </a>
          <a href="https://pmindia.gov.in" target="_blank" rel="noopener noreferrer">
            <img src={`${process.env.PUBLIC_URL}/images/pm-india-logo.jpeg`} alt="PM India" />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default Home;
